<app-base-auth-form [message]="'Auth.CompleteSignUpMessage' | i18next" [action]="'Auth.ConfirmSignUp' | i18next"
    slot="main-content" [isBusy]="isBusy" [errorMessage]="errorMessage" (performAction)="completeSignUp()">

    <dx-text-box [label]="'Auth.Email' | i18next" labelMode="floating" valueChangeEvent="keyup"
        class="item large-top-space" [(value)]="email" (valueChange)="resetError()"></dx-text-box>

    <dx-text-box [label]="'Auth.Code' | i18next" labelMode="floating" valueChangeEvent="keyup" class="item top-space"
        [(value)]="verificationCode" (valueChange)="resetError()" (onEnterKey)="completeSignUp()"></dx-text-box>

</app-base-auth-form>